module.exports = __webpack_public_path__ + "img/taocan-list-img.e34f3b99.png";